import { createBrowserRouter, RouterProvider } from "react-router-dom";

import routes from "./routes";
// Import styles
import "css/collectors.min.css";

// Create router
const router = createBrowserRouter(routes);

function App() {
  return <RouterProvider router={router} />;
}

export default App;
